const cloudinaryConfig = {
    cloud_name: 'rauru',
    api_key: '276528539619829',
}

export default cloudinaryConfig;
